import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterEditorDialogComponent } from './filter-editor-dialog/filter-editor-dialog.component';
import { ControlsModule } from '../controls/controls.module';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { FilterStatisticsDialogComponent } from './filter-statistics-dialog/filter-statistics-dialog.component';
import { PortletModule } from '../../../views/partials/content/general/portlet/portlet.module';
import { PartialsModule } from '../../../views/partials/partials.module';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { InfoDialogComponent } from './info-dialog/info-dialog.component';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { FilterCategoryDialogComponent } from './filter-category-dialog/filter-category-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
    declarations: [FilterEditorDialogComponent, FilterStatisticsDialogComponent,
        ConfirmDialogComponent,
        InfoDialogComponent,FilterCategoryDialogComponent],
    exports: [FilterEditorDialogComponent, ConfirmDialogComponent, InfoDialogComponent],
    imports: [
        CommonModule,
        ControlsModule,
        MatButtonModule,
        PortletModule,
        PartialsModule,
        MatIconModule,
        MatFormFieldModule,
        MatDividerModule,
        YouTubePlayerModule,
        MatDialogModule
    ]
})
export class DialogsModule { }
